"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconInfoSquare = function IconInfoSquare(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconInfoSquare', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Symbols",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "feedback",
    fill: "currentColor"
  }, _react.default.createElement("g", {
    id: "Mask"
  }, _react.default.createElement("path", {
    d: "M3,1.5 C2.17157288,1.5 1.5,2.17157288 1.5,3 L1.5,13 C1.5,13.8284271 2.17157288,14.5 3,14.5 L13,14.5 C13.8284271,14.5 14.5,13.8284271 14.5,13 L14.5,3 C14.5,2.17157288 13.8284271,1.5 13,1.5 L3,1.5 Z M3,0 L13,0 C14.6568542,0 16,1.34314575 16,3 L16,13 C16,14.6568542 14.6568542,16 13,16 L3,16 C1.34314575,16 0,14.6568542 0,13 L0,3 C0,1.34314575 1.34314575,0 3,0 Z",
    id: "Rectangle",
    fillRule: "nonzero"
  }), _react.default.createElement("g", {
    id: "nav-support",
    transform: "translate(6.000000, 1.000000)",
    fontFamily: "SFProRounded-Bold, SF Pro Rounded",
    fontSize: "13",
    fontWeight: "bold"
  }, _react.default.createElement("text", {
    id: "!"
  }, _react.default.createElement("tspan", {
    x: "0",
    y: "12"
  }, "!")))))));
};

var _default = IconInfoSquare;
exports.default = _default;